var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"NormalText1_inner"},[_c('pre',[_vm._v("    "),_c('div',{domProps:{"innerHTML":_vm._s(this.text)}}),_vm._v("\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }